import React, { useState, useRef } from "react";
import "../parkingForms/form.css";

function DayParking() {
  const [formData, setFormData] = useState({
    customerName: "",
    contactNumber: "",
    email: "",
    vehicleNumber: "",
    vehicleType: "",
    entryDate: "",
    parkingSlot: "",
    vehicleImage: null,
  });

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [isCameraOn, setIsCameraOn] = useState(false);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "vehicleType") {
      let apiUrl = "";

      if (value === "Bike") {
        apiUrl = `${process.env.REACT_APP_BASE_API_URL}/twoWheelerSlots/api/get`;
      } else if (value === "lmv") {
        apiUrl = `${process.env.REACT_APP_BASE_API_URL}/lmvSlots/api/get`;
      } else if (value === "hmv") {
        apiUrl = `${process.env.REACT_APP_BASE_API_URL}/hmvSlots/api/get`;
      }

      if (apiUrl) {
        try {
          const response = await fetch(apiUrl);
          if (!response.ok) throw new Error("Failed to fetch slots");
          const data = await response.json();

          if (Array.isArray(data.data)) {
            setAvailableSlots(data.data);
          } else {
            setAvailableSlots([]);
          }
        } catch (err) {
          console.error("Error fetching slots:", err);
          setAvailableSlots([]);
        }
      } else {
        setAvailableSlots([]);
        setFormData((prev) => ({ ...prev, parkingSlot: "" }));
      }
    }
  };

  const startCamera = async () => {
    setIsCameraOn(true);
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    videoRef.current.srcObject = stream;
  };

  const captureImage = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      setCapturedImage(URL.createObjectURL(blob));
      setFormData((prev) => ({ ...prev, vehicleImage: blob }));
    }, "image/png");

    video.srcObject.getTracks().forEach((track) => track.stop());
    setIsCameraOn(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const formDataToSend = new FormData();
      formDataToSend.append("customerName", formData.customerName);
      formDataToSend.append("contactNumber", formData.contactNumber);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("vehicleNumber", formData.vehicleNumber);
      formDataToSend.append("vehicleType", formData.vehicleType);
      formDataToSend.append("entryDate", formData.entryDate);
      formDataToSend.append("parkingSlot", formData.parkingSlot);

      if (formData.vehicleImage) {
        formDataToSend.append("vehicleImage", formData.vehicleImage, "vehicle-image.png");
      }

      const parkingResponse = await fetch(`${process.env.REACT_APP_BASE_API_URL}/dayRentalParking/api/create`, {
        method: "POST",
        body: formDataToSend,
      });

      if (!parkingResponse.ok) throw new Error("Day parking registration failed!");

      alert("Data successfully stored in both databases!");
      handleClear();
    } catch (error) {
      console.error("Error:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const handleClear = () => {
    setFormData({
      customerName: "",
      contactNumber: "",
      email: "",
      vehicleNumber: "",
      vehicleType: "",
      entryDate: "",
      parkingSlot: "",
      vehicleImage: null,
    });
    setCapturedImage(null);
    setAvailableSlots([]);
  };

  return (
    <div className="hourlyParking container">
      <form className="p-4 border rounded shadow" onSubmit={handleSubmit}>
        <h2>Enter Daily Vehicle Details</h2>
        <p>Enter all necessary details correctly...</p>

        <div className="form-group">
          <label>Customer Name</label>
          <input
            type="text"
            name="customerName"
            className="form-control"
            placeholder="Enter Name"
            value={formData.customerName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Contact Number</label>
          <input
            type="tel"
            name="contactNumber"
            className="form-control"
            placeholder="Enter Contact Number"
            value={formData.contactNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>E-mail Id</label>
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="Enter E-mail (Optional)"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Vehicle Number</label>
          <input
            type="text"
            name="vehicleNumber"
            className="form-control"
            placeholder="Enter Vehicle Number"
            value={formData.vehicleNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Vehicle Type</label>
          <select
            name="vehicleType"
            className="form-control"
            value={formData.vehicleType}
            onChange={handleChange}
            required
          >
            <option value="" disabled>Select Vehicle Type</option>
            <option value="Bike">Two Wheeler</option>
            <option value="lmv">Car (LMV)</option>
            <option value="hmv">Truck/Bus (HMV)</option>
          </select>
        </div>

        {(formData.vehicleType === "Bike" || formData.vehicleType === "lmv" || formData.vehicleType === "hmv") && (
          <div className="form-group">
            <label>Parking Slot ({formData.vehicleType})</label>
            <select
              name="parkingSlot"
              className="form-control"
              value={formData.parkingSlot}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Select Available Slots</option>
              {availableSlots.map((slot) => (
                <option key={slot._id} value={slot.slots}>
                  {slot.slots}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-group">
          <label>Vehicle Entry Date</label>
          <input
            type="date"
            name="entryDate"
            className="form-control"
            value={formData.entryDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Capture Vehicle Image</label>
          {!isCameraOn ? (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={startCamera}
            >
              Open Camera
            </button>
          ) : (
            <>
              <video
                ref={videoRef}
                autoPlay
                className="border rounded w-100"
              ></video>
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={captureImage}
              >
                Capture Image
              </button>
            </>
          )}

          {capturedImage && (
            <div className="mt-3">
              <p>Captured Image Preview:</p>
              <img
                src={capturedImage}
                alt="Captured"
                className="img-thumbnail"
                width="200"
              />
            </div>
          )}
        </div>

        <div className="action text-center mt-3">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <button
            type="button"
            className="btn btn-danger ml-2"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </form>

      <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
    </div>
  );
}

export default DayParking;
